import { CaFscRow } from "../../pages/settings/linehaul/rates-and-accessorial/cal-fsc/caFscRow.type";
import type { CaFscDistinctFilterName } from "../../hooks/react-query/settings/linehaul/useCaFsc";

export const MOCK_CA_FSC_DISTINCT_VALUES: Record<
  CaFscDistinctFilterName,
  string[]
> = {
  toFrom: ["LAX", "ONT", "SFO", "VIS"],
  fromTo: ["ATL", "BOS", "CHT", "CHI-PITDLT", "DEN", "HOU", "MIA"],
};

export const MOCK_CA_FSC_DATA: CaFscRow[] = [
  {
    id: 1,
    toFrom: "LAX",
    fromTo: "ATL",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: "2026-03-15",
  },
  {
    id: 2,
    toFrom: "ONT",
    fromTo: "ATL",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: null,
  },
  {
    id: 3,
    toFrom: "SFO",
    fromTo: "ATL",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: null,
  },
  {
    id: 4,
    toFrom: "VIS",
    fromTo: "ATL",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: "2026-01-12",
  },
  {
    id: 5,
    toFrom: "LAX",
    fromTo: "BOS",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: "2026-03-15",
  },
  {
    id: 6,
    toFrom: "ONT",
    fromTo: "BOS",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: "2026-03-15",
  },
  {
    id: 7,
    toFrom: "SFO",
    fromTo: "BOS",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: null,
  },
  {
    id: 8,
    toFrom: "VIS",
    fromTo: "BOS",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: "2026-03-15",
  },
  {
    id: 9,
    toFrom: "LAX",
    fromTo: "CHT",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: null,
  },
  {
    id: 10,
    toFrom: "SFO",
    fromTo: "CHT",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: null,
  },
  {
    id: 11,
    toFrom: "ONT",
    fromTo: "CHT",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: null,
  },
  {
    id: 12,
    toFrom: "VIS",
    fromTo: "CHT",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: "2026-03-15",
  },
  {
    id: 13,
    toFrom: "LAX",
    fromTo: "CHI-PITDLT",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: null,
  },
  {
    id: 14,
    toFrom: "ONT",
    fromTo: "CHI-PITDLT",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: null,
  },
  {
    id: 15,
    toFrom: "SFO",
    fromTo: "CHI-PITDLT",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: null,
  },
  {
    id: 16,
    toFrom: "VIS",
    fromTo: "CHI-PITDLT",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: null,
  },
  {
    id: 17,
    toFrom: "LAX",
    fromTo: "DEN",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: null,
  },
  {
    id: 18,
    toFrom: "ONT",
    fromTo: "DEN",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: null,
  },
  {
    id: 19,
    toFrom: "SFO",
    fromTo: "DEN",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: null,
  },
  {
    id: 20,
    toFrom: "VIS",
    fromTo: "DEN",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: null,
  },
  {
    id: 21,
    toFrom: "LAX",
    fromTo: "HOU",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: null,
  },
  {
    id: 22,
    toFrom: "ONT",
    fromTo: "HOU",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: null,
  },
  {
    id: 23,
    toFrom: "SFO",
    fromTo: "HOU",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: null,
  },
  {
    id: 24,
    toFrom: "VIS",
    fromTo: "HOU",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: null,
  },
  {
    id: 25,
    toFrom: "LAX",
    fromTo: "MIA",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: "2026-01-12",
  },
  {
    id: 26,
    toFrom: "ONT",
    fromTo: "MIA",
    rate: 2.53,
    effectiveDate: "2026-01-01",
    expirationDate: null,
  },
];
